import React from 'react';
import PropTypes from 'prop-types';
import Tab from 'react/containers/layout/tabs/Tab';

import { fixGridAndFilterBuilder } from 'react/utils/utils';
import { CoordinatesAlert } from 'react/components/Maps';

class RouteDetails extends Tab {

  static propTypes = {
    onClose: PropTypes.func,
    active: PropTypes.bool,
    tab: PropTypes.object,
  }

  activeClassName = 'is-active'

  componentDidMount() {
    try {
      const { tab: { extra: { routeId, mode, childrenId } } } = this.props;
      this.router = new App.Routers.RouteDetails();
      switch (mode) {
        case 'stop':
          this.router.show(routeId, childrenId);
          break;
        case 'event':
          this.router.showOnEventFocus(routeId, childrenId);
          break;
        default:
          this.router.show(routeId);
      }
    } catch (error) {
      console.log(error);
    }
  }

  removeMapInstance(map) {
    map.off();
    map.remove();
  }

  clearObjects() {
    const { tab: { extra: { routeId } } } = this.props;
    const screenData = Monet.Session.RouteDetail.screensList?.[routeId];

    if (!screenData) return;

    const { map, mapBaseLayer } = screenData


    this.removeMapInstance(map);
    this.removeMapInstance(mapBaseLayer);

    App.Forms[`RouteDetails_${routeId}`].table.destroy();

    delete App.Objects[`RouteDetails_${routeId}`];
    delete App.Forms[`RouteDetails_${routeId}`];
    delete App.Forms[`RouteDetails_${routeId}_ResequenceHistory`];
    delete App.Objects[`RouteDetails_${routeId}_ResequenceHistory`];
    delete Monet.Session.RouteDetail.screensList[routeId];
  }

  componentWillUnmount() {
    this.clearObjects();
  }

  updateMapAndGrids(isComingFromAnotherTab, didChangeTab) {
    const { tab: { extra: { routeId } } } = this.props;
    const {
      map,
      shouldUpdate,
    } = Monet.Session.RouteDetail.screensList[routeId];

    if (shouldUpdate) {
      //Update this Route Details screen if shouldUpdate was set as true
      this.router.processMapUpdates();
    }

    if (!isComingFromAnotherTab && didChangeTab) {
      this.router.updateOptimizationHistory(routeId);
    }

    if (map?.invalidateSize) {
      map.invalidateSize();
    }

    const routeDetailTab = `RouteDetails_${routeId}`;
    const grid = App.Forms[routeDetailTab].table;
    const gridStops = App.Forms[routeDetailTab].gridStops;

    if (grid) {
      grid.resizeCanvas();
      grid.invalidate();
      gridStops.addFilterBuilder();
    }

    const resequenceHistoryForm = App.Forms[`RouteDetails_${routeId}_ResequenceHistory`];
    if (resequenceHistoryForm) {
      const resequenceHistoryTable = resequenceHistoryForm.table;
      const resequenceHistoryGrid = resequenceHistoryForm.gridResequenceHistory;

      resequenceHistoryTable?.resizeCanvas();
      resequenceHistoryTable?.invalidate();
      resequenceHistoryGrid?.addFilterBuilder();
    }
  }

  componentDidUpdate(prevProps) {
    const { tab: { pathname, extra: { routeId } }, active } = this.props;
    const isComingFromAnotherTab = active !== prevProps.active;
    const didChangeTab = pathname !== prevProps.tab.pathname;

    if (Monet.Session.RouteDetail.screensList[routeId]) {
      const {
        shouldOpenPopup,
        mapRouteDetail,
        router,
      } = Monet.Session.RouteDetail.screensList[routeId];
      const eventId = router?.eventId
      if (isComingFromAnotherTab && active) {
        fixGridAndFilterBuilder();
        if (mapRouteDetail && shouldOpenPopup && eventId) {
          mapRouteDetail.focusOnTheEvent(eventId);
        }
      }

      if (active) {
        this.updateMapAndGrids(isComingFromAnotherTab, didChangeTab);
      }
    }
  }


  render() {
    const {
      active,
      tab: { key: liveKey, extra: { routeId } }
    } = this.props;
    const className = `gmTabs__panel ${(active) ? this.activeClassName : ''}`;

    return (
      <div id={ liveKey } className={ className }>
        <div>
          <div id={`routeMaps_${Number(routeId)}`} data-testid={`routeMaps_${Number(routeId)}`} />
          <CoordinatesAlert alertKey="routeDetailsCoords" />
        </div>
      </div>
    );
  }
}

export default RouteDetails;
